import { render, staticRenderFns } from "./alert-notifications.vue?vue&type=template&id=7d8498dc&scoped=true&"
import script from "./alert-notifications.js?vue&type=script&lang=js&"
export * from "./alert-notifications.js?vue&type=script&lang=js&"
import style0 from "./alert-notifications.scss?vue&type=style&index=0&id=7d8498dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8498dc",
  null
  
)

component.options.__file = "alert-notifications.vue"
export default component.exports